import { View } from "binder"
import { NetworkedStationEditorViewModel } from "./networkedStationEditor-viewModel"

export class NetworkedStationEditorView extends View<NetworkedStationEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-D0804760-2F6A-495F-8A44-F7C048B85CFD"
    }
    loadHtml(): string {
        let element = require('./networkedStationEditor.html').default;
        let style = require('./networkedStationEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set macAddress(v: string) { this._macAddress = v; } public get macAddress(): string { return this._macAddress; } private _macAddress: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
